import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import KeywordChart from "./KeywordChart";

interface KeywordTabChartProps {
  positiveData?: any[]; // 正面关键词数据
  negativeData?: any[]; // 负面关键词数据
  className?: string;
  style?: React.CSSProperties;
  onPositiveKeywordClick?: (
    name: string,
    weight: number,
    keywordId?: string
  ) => void;
  onNegativeKeywordClick?: (
    name: string,
    weight: number,
    keywordId?: string
  ) => void;
  onTabChange?: (tab: "positive" | "negative") => void;
}

// 样式配置
const STYLES = {
  container: {
    background: "transparent",
    borderRadius: 0,
    border: "none",
    boxShadow: "none",
    overflow: "visible",
  },
  tabContainer: {
    display: "flex",
    background: "transparent",
    borderRadius: 0,
    padding: 0,
    boxShadow: "none",
    border: "none",
    margin: "0 0 16px 0",
    gap: 40,
  },
  tabButton: {
    padding: "8px 16px",
    border: "1px solid #e5e7eb",
    borderRadius: 20,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    transition: "all 0.2s ease",
    whiteSpace: "nowrap" as const,
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
  },
  chartContainer: {
    padding: "0",
    background: "#ffffff",
    borderRadius: 6,
    boxShadow: "0 2px 8px -2px rgba(0,0,0,.08)",
    overflow: "hidden",
    margin: "auto",
  },
} as const;

const KeywordTabChart: React.FC<KeywordTabChartProps> = ({
  positiveData = [],
  negativeData = [],
  className,
  style,
  onPositiveKeywordClick,
  onNegativeKeywordClick,
  onTabChange,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<"positive" | "negative">(
    "positive"
  );

  const currentData = activeTab === "positive" ? positiveData : negativeData;
  const currentClickHandler =
    activeTab === "positive" ? onPositiveKeywordClick : onNegativeKeywordClick;

  return (
    <div className={className} style={{ ...STYLES.container, ...style }}>
      {/* 标题 */}
      <div style={{ marginBottom: 16 }}>
        <span
          style={{
            whiteSpace: "nowrap",
            color: "rgb(148, 163, 184)",
            fontSize: 16,
          }}
        >
          {t("common.charts.keyword_tab_industry")}
        </span>
      </div>

      {/* Tab 切换按钮 */}
      <div style={STYLES.tabContainer}>
        <button
          type="button"
          style={{
            ...STYLES.tabButton,
            background:
              activeTab === "positive" ? "rgb(33, 196, 184)" : "transparent",
            color: activeTab === "positive" ? "#ffffff" : "#6b7280",
          }}
          onClick={() => {
            setActiveTab("positive");
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            onTabChange && onTabChange("positive");
          }}
        >
          {t("common.charts.keyword_tab_positive")}
        </button>
        <button
          type="button"
          style={{
            ...STYLES.tabButton,
            background:
              activeTab === "negative"
                ? "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)"
                : "transparent",
            color: activeTab === "negative" ? "#ffffff" : "#6b7280",
          }}
          onClick={() => {
            setActiveTab("negative");
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            onTabChange && onTabChange("negative");
          }}
        >
          {t("common.charts.keyword_tab_negative")}
        </button>
      </div>

      {/* 词云图内容 */}
      <div style={STYLES.chartContainer}>
        <KeywordChart
          keywords={currentData}
          height={350}
          onKeywordClick={currentClickHandler}
        />
      </div>
    </div>
  );
};

export default KeywordTabChart;
